
import React, { Component } from "react";
import { Tabs } from "antd";
import SideNav from "../SideNav";
import StartService from "./StartService";
import BasicService from "./BasicService";
import CustomsCenter from "./CustomsCenter";
import ManagementService from "./ManagementService";

const TabPane = Tabs.TabPane;

const tabs = [{
    tab:'启动服务单价',
    key:'startService',
},{
    tab:'基础服务单价',
    key:'basicService',
},{
    tab:'锁库关中心单价',
    key:'customsCenter',
},{
    tab:'项目管理服务',
    key:'managementService',
}]

class TaskUnitPrice extends Component {
    state = {
        activeKey: 'startService',
        content: <StartService />,
    }

    handleTabClick = (key) => {
        let { content } = this.state;
        switch (key) {
            case 'startService':
                content = <StartService />;
                break;
            case 'basicService':
                content = <BasicService />;
                break;
            case 'customsCenter':
                content = <CustomsCenter />;
                break;
            case 'managementService':
                content = <ManagementService />;
                break;
        }
        this.setState({ activeKey: key, content})
    }

    render() {
        const { activeKey, content } = this.state
        return (
            <div className="content">
                <SideNav selectKey="task" />
                <div className='main'>
                    <Tabs type="card" activeKey={activeKey} onChange={this.handleTabClick}>
                        {tabs.map(pane => <TabPane tab={pane.tab} key={pane.key}></TabPane>)}
                    </Tabs>
                    { content }
                </div>
            </div>
        )
    }
}

export default TaskUnitPrice;



// WEBPACK FOOTER //
// ./src/components/businessOffer/taskUnitPrice/index.js